"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEuCountryCode = exports.ISO_CODES_TO_VAT_PREFIX_CODES_FOR_EU_COUNTRIES = exports.startsWithCountryCode = void 0;
/**
 * Check if the VAT number starts with proper country code needed for VIES validation
 * For example: PL1234567890, where PL is the country code for Poland, DE1234567890, where DE is the country code for Germany
 *
 * @param vatNumber
 * @param countryIso country iso code (e.g. pl, de, gr, etc.)
 */
function startsWithCountryCode(vatNumber, countryIso) {
    const countryVatCode = getEuCountryCode(countryIso);
    return vatNumber.startsWith(countryVatCode);
}
exports.startsWithCountryCode = startsWithCountryCode;
exports.ISO_CODES_TO_VAT_PREFIX_CODES_FOR_EU_COUNTRIES = {
    GR: "EL",
};
/**
 * Each European Union country has its own country code, which translates to the VAT number prefix.
 * In most cases, the country code is the same as the ISO code, but there is an exception for Greece,
 * which has the country code "EL" and ISO code "GR".
 */
function getEuCountryCode(countryIso) {
    const upperCaseIso = countryIso.toUpperCase();
    return exports.ISO_CODES_TO_VAT_PREFIX_CODES_FOR_EU_COUNTRIES[upperCaseIso] ?? upperCaseIso;
}
exports.getEuCountryCode = getEuCountryCode;
//# sourceMappingURL=getEuCountryCode.js.map